import {Box, Typography} from '@mui/material';

import {getScoreLevelColors, scorePillChipSx} from '../../../../../utils/getScoreLevelColors';

export interface Props {
  score: number | null;
}

export const WorkforceDashboardRoleCoverageHeatmapScoreCell = ({score}: Props) => {
  if (score === null) {
    return (
      <Typography variant='body2' sx={{color: 'text.secondary'}}>
        —
      </Typography>
    );
  }

  const {bgcolor, color} = getScoreLevelColors(score);

  return (
    <Box
      component='span'
      sx={{
        display: 'inline-block',
        minWidth: 52,
        px: 1.25,
        py: 0.5,
        borderRadius: '6px',
        fontSize: 12,
        fontWeight: 600,
        bgcolor,
        color,
        ...scorePillChipSx,
      }}
    >
      {score}%
    </Box>
  );
};
